import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChild,
    ViewChildren,
    ViewEncapsulation,
    ChangeDetectionStrategy,
} from '@angular/core';
import { CheckboxComponent, CheckboxModel } from '@fi-shared/checkbox';
import { CheckboxListModel } from './checkbox-list.model';

@Component({
    selector: 'fi-checkbox-list',
    templateUrl: './checkbox-list.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./checkbox-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CheckboxListComponent implements OnInit {
    @Input() checkboxListSettings: CheckboxListModel;
    @Input() disableIds: Array<number> = [];
    @Input() disableTitle: string;
    @Input() isAllDisabled: boolean = false;
    @ViewChild('headerCheckbox', { static: false }) headerCheckbox: CheckboxComponent;
    @ViewChildren('childCheckbox') childrenCheckboxes: QueryList<CheckboxComponent>;

    @Output('change') changeOutput = new EventEmitter<any[]>();

    Header: any;

    ngOnInit() {
        this.Header = new CheckboxModel({
            Name: this.checkboxListSettings.HeaderName,
            ShowHeader: this.checkboxListSettings.ShowHeader,
        });
        this.checkboxListSettings.onIsHeaderEnabledChange.subscribe((isHeaderEnabled) => {
            this.Header.IsEnabled = isHeaderEnabled;
        });
        this.Header.Checked = this.checkboxListSettings.DataSet.some((item) => item.Checked);
    }

    isCheckboxDisabled(item) {
        return this.isAllDisabled
            ? this.isAllDisabled
            : (this.disableIds && this.disableIds.indexOf(item.Id) > -1) ||
                  (item.ChildItems &&
                      item.ChildItems.length &&
                      item.ChildItems.every((childItem) => !childItem.IsEnabled));
    }

    getDisabledCheckboxTitle(item) {
        if (this.isCheckboxDisabled(item)) return this.disableTitle;
    }

    headerCheckedChange() {
        if (!this.checkboxListSettings.AllowMultiSelect) return;

        const changedItems = [];
        this.childrenCheckboxes.forEach((checkbox) => {
            if (!checkbox.isDisabled()) {
                changedItems.push(checkbox.checkboxSettings);
                checkbox.setCheckedState(this.Header.Checked);
            }
        });

        this.changeOutput.emit(changedItems);
    }

    childCheckedChange(item) {
        if (this.checkboxListSettings.IsHeaderCheckboxHidden) {
            this.changeOutput.emit([item]);
            return;
        }

        if (item.Checked) {
            this.headerCheckbox.setCheckedState(true);
        } else {
            this.headerCheckbox.setCheckedState(this.childrenCheckboxes.some((item) => item.isChecked()));
        }

        this.updateHeaderIndeterminateState();
        this.changeOutput.emit([item]);
    }

    updateHeaderIndeterminateState() {
        // header considered as indeterminate when some of children are selected,
        // but not all of them or some of them are indeterminate
        if (this.checkboxListSettings.IsHeaderCheckboxHidden) return;

        this.headerCheckbox.setIndeterminateState(
            this.childrenCheckboxes.some((item) => item.isChecked()) &&
                !this.childrenCheckboxes.toArray().every((item) => item.isChecked() && !item.isIndeterminate()),
        );
    }

    childIndeterminateChange() {
        this.updateHeaderIndeterminateState();
    }
}
